import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from '../Page/HomePage'
import UserDashboard from '../Page/UserDashboard'
import SupervisorDashboard from '../Page/SupervisorDashboard'
import CreateCard from '../Page/CreateCard'
import CardPreview from '../Page/CardPreview'
import ProtectedRoute from '../Components/ProtectedRoute'

export default function IndexRoute() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <UserDashboard />
        </ProtectedRoute>
      } />
      <Route path="/supervisor" element={
        <ProtectedRoute requiredRole="Supervisor">
          <SupervisorDashboard />
        </ProtectedRoute>
      } />
      <Route path="/create" element={
        <ProtectedRoute>
          <CreateCard />
        </ProtectedRoute>
      } />
      <Route path="/preview/:id" element={<CardPreview />} />
    </Routes>
  )
}
